import { Link } from 'react-router-dom';
import { studio } from '@/mocks/projects';
import { useGoToHomeSection } from '@/lib/home-nav';
import Reveal from '@/lib/motion/Reveal';

// Inverted ending: dark footer in Light mode, light footer in Dark mode (uses existing tokens only).
const micro = 'font-label text-[11px] font-medium uppercase tracking-[0.12em] text-background-50/55';
const link = 'mo-uline self-start text-[13px] text-background-50 whitespace-nowrap cursor-pointer';

export default function SiteFooter() {
  const goToHomeSection = useGoToHomeSection();
  const homeLink = (id: string, label: string) => (
    <a href={`/#${id}`} className={link} onClick={(e) => { e.preventDefault(); goToHomeSection(id); }}>{label}</a>
  );
  return (
    <footer className="bg-foreground-950 px-4 pb-8 pt-14 text-background-50 md:px-10 md:pt-16">
      <Reveal variant="footer" className="mx-auto max-w-[1200px]">
        <div className="grid grid-cols-2 gap-10 md:grid-cols-12">
          <div className="col-span-2 md:col-span-5">
            <p className="font-label text-[11px] font-medium uppercase tracking-[0.12em] text-background-50">{studio.name} Photography</p>
            <p className="mt-4 max-w-xs text-[13px] leading-relaxed text-background-50/60">Campaign, portrait and editorial photography.</p>
          </div>
          <div className="md:col-span-3">
            <p className="text-[13px] text-background-50">{studio.location}</p>
            <a href={`mailto:${studio.email}`} className={`${link} mt-2 inline-block text-background-50/60`}>{studio.email}</a>
          </div>
          <div className="flex flex-col gap-2 md:col-span-2">
            <p className="text-[13px] text-background-50">Instagram <span className="text-background-50/60">{studio.instagram}</span></p>
            <p className="text-[13px] text-background-50">Vimeo</p>
          </div>
          <nav className="flex flex-col gap-2 md:col-span-2" aria-label="Footer">
            {homeLink('work', 'Work')}
            <Link to="/studio" className={link}>Studio</Link>
            {homeLink('services', 'Services')}
            <Link to="/contact" className={link}>Contact</Link>
          </nav>
        </div>
        <div className="mt-14 flex flex-col gap-2 border-t border-background-50/15 pt-6 sm:flex-row sm:justify-between">
          <p className={micro}>© 2026 {studio.name}</p>
          <p className={micro}>All photographs by {studio.name}</p>
        </div>
      </Reveal>
    </footer>
  );
}